import { useIdentity } from "@equipmentshare/auth0-react"
import { useHeaper } from "@equipmentshare/heaper"

import { IS_PROD } from "@app/services/env"

export function HeaperInit() {
    const { idToken, accessToken } = useIdentity()
    useHeaper("MttBulkLabelGenerator", IS_PROD ? "Production" : "Staging", {
        intercom: true,
        internalProducts: true,
        idToken,
        accessToken,
    })
    return null
}
